export default {
    qr_uri: null,
    secret_key: null,
    tfa_token: null,
}
